/**
 * Typed event emitter for the rendition engine.
 * Thin wrapper around EventTarget for type safety.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Handler = (...args: any[]) => void;

export class Emitter {
  private _handlers = new Map<string, Set<Handler>>();

  on(event: string, fn: Handler): this {
    let set = this._handlers.get(event);
    if (!set) {
      set = new Set();
      this._handlers.set(event, set);
    }
    set.add(fn);
    return this;
  }

  off(event: string, fn: Handler): this {
    this._handlers.get(event)?.delete(fn);
    return this;
  }

  once(event: string, fn: Handler): this {
    const wrapped: Handler = (...args) => {
      this.off(event, wrapped);
      fn(...args);
    };
    return this.on(event, wrapped);
  }

  emit(event: string, ...args: unknown[]): void {
    const set = this._handlers.get(event);
    if (!set) return;
    for (const fn of set) {
      try {
        fn(...args);
      } catch (e) {
        console.error(`[Emitter] error in "${event}" handler:`, e);
      }
    }
  }

  removeAllListeners(event?: string): void {
    if (event) {
      this._handlers.delete(event);
    } else {
      this._handlers.clear();
    }
  }
}
